import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";

import "./DefaultLayout.css";

import AppSidebar from "./app_sidebar/AppSidebar";
import AppHeader from "./app_header/AppHeader";
import AppContent from "./app_content/AppContent";

const DefaultLayout = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  return (
    <div className="DefaultLayout">
      {/* Desktop sidebar (≥ 992px) */}
      <aside className="layout_sidebar">
        <AppSidebar />
      </aside>

      {/* Mobile / tablet drawer (< 992px) */}
      <Offcanvas
        className="mobile_offcanvas"
        show={showSidebar}
        onHide={handleClose}
        placement="start"
      >
        <Offcanvas.Body>
          <AppSidebar closeSidebar={handleClose} showClose />
        </Offcanvas.Body>
      </Offcanvas>

      <div className="layout_main">
        <div className="header_holder">
          <AppHeader onMenuClick={handleShow} />
        </div>

        <main className="content-div">
          <AppContent />
        </main>
      </div>
    </div>
  );
};

export default DefaultLayout;
